import { getAuthProps, setAuthProps } from "@/services";
import { removeAllCookies } from "@/utils";
import { createSlice } from "@reduxjs/toolkit";

const authData = getAuthProps();

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: authData != null,
    isLogedin: !!authData,
    token: authData?.token,
    authData,
    email: authData?.email,
    contact: authData?.contact,
    userName: authData?.personName,
    roleId: authData?.roleId,
    companyId: authData?.companyId,
    companyName: authData?.name,
  },
  reducers: {
    authentication: (state, action) => {
      const authData = action.payload;
      setAuthProps(authData);
      state.isLogedin = true;
      state.isAuthenticated = true;
      state.authData = authData;
      state.token = authData.token;
      state.email = authData.email;
      state.contact = authData.contact;
      state.userName = authData.personName;
      state.roleId = authData.roleId;
      state.companyId = authData.companyId;
      state.companyName = authData.name;
    },
    logout: (state) => {
      removeAllCookies();
      state.isLogedin = false;
      state.isAuthenticated = false;
      state.authData = null;
      state.token = null;
    },
  },
});

export const { authentication, logout } = authSlice.actions;
export default authSlice.reducer;
